import { render, staticRenderFns } from "./SelectCombo.vue?vue&type=template&id=23d9f2bb&scoped=true&"
import script from "./SelectCombo.vue?vue&type=script&lang=js&"
export * from "./SelectCombo.vue?vue&type=script&lang=js&"
import style0 from "./SelectCombo.vue?vue&type=style&index=0&id=23d9f2bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9f2bb",
  null
  
)

export default component.exports